import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "release-notes"
    }}>{`Release Notes`}</h1>
    <h2 {...{
      "id": "august-25-2022"
    }}>{`August 25, 2022`}</h2>
    <h3 {...{
      "id": "ios-acpanalytics-254"
    }}>{`iOS ACPAnalytics 2.5.4`}</h3>
    <ul>
      <li parentName="ul">{`Fix race conditions in AnalyticsHitQueue to prevent crash related to concurrent reset of database.`}</li>
    </ul>
    <h2 {...{
      "id": "june-7-2022"
    }}>{`June 7, 2022`}</h2>
    <h3 {...{
      "id": "ios-acpanalytics-253"
    }}>{`iOS ACPAnalytics 2.5.3`}</h3>
    <ul>
      <li parentName="ul">{`Fix crash in AnalyticsHitDatabase caused by unprotected shared access of AnalyticsState object.`}</li>
    </ul>
    <h2 {...{
      "id": "may-24-2022"
    }}>{`May 24, 2022`}</h2>
    <h3 {...{
      "id": "ios-analytics-252"
    }}>{`iOS Analytics 2.5.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug for the integration with Assurance where "No Debug Flag" was showing in the UI for some events.`}</li>
    </ul>
    <h2 {...{
      "id": "march-3-2022"
    }}>{`March 3, 2022`}</h2>
    <h3 {...{
      "id": "android-analytics-1210"
    }}>{`Android Analytics 1.2.10`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug for the integration with Assurance where "No Debug Flag" was showing in the UI for some events.`}</li>
    </ul>
    <h2 {...{
      "id": "october-21-2021"
    }}>{`October 21, 2021`}</h2>
    <h3 {...{
      "id": "android-analytics-129"
    }}>{`Android Analytics 1.2.9`}</h3>
    <ul>
      <li parentName="ul">{`Add support for `}<inlineCode parentName="li">{`MobileCore.resetIdentities()`}</inlineCode>{` API. When this API is called, the Analytics identifiers and the Analytics hits queue are cleared.`}</li>
      <li parentName="ul">{`Bug fixes to improve SDK stability.`}</li>
    </ul>
    <h2 {...{
      "id": "july-21-2021"
    }}>{`July 21, 2021`}</h2>
    <h3 {...{
      "id": "android-analytics-128"
    }}>{`Android Analytics 1.2.8`}</h3>
    <ul>
      <li parentName="ul">{`Fixed undefined dependencies in .pom file, preventing developers from including the v1.2.7 analytics library through Gradle.`}</li>
    </ul>
    <h3 {...{
      "id": "android-analytics-127"
    }}>{`Android Analytics 1.2.7`}</h3>
    <ul>
      <li parentName="ul">{`Removed retrieval and generation of Analytics tracking identifier (AID). Existing AID values stored on the device will continue to be loaded and used, however new visitors will not be assigned an AID value.`}</li>
      <li parentName="ul"><strong parentName="li">{`IMPORTANT`}</strong>{`: If you encounter issues including this dependency through Gradle, 1.2.8 fixes the error.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-analytics-251"
    }}>{`iOS Analytics 2.5.1`}</h3>
    <ul>
      <li parentName="ul">{`Removed retrieval and generation of Analytics tracking identifier (AID). Existing AID values stored on the device will continue to be loaded and used, however new visitors will not be assigned an AID value.`}</li>
    </ul>
    <h2 {...{
      "id": "december-18-2020"
    }}>{`December 18, 2020`}</h2>
    <h3 {...{
      "id": "ios-analytics-250"
    }}>{`iOS Analytics 2.5.0`}</h3>
    <ul>
      <li parentName="ul">{`The AEP SDKs are now distributed using XCFrameworks in order to support hardware with the new Apple M1 architecture while maintaining support for existing Intel architecture.`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`IMPORTANT`}</strong>{`: Upgrading to XCFrameworks distribution requires Xcode 12.0 or newer`}</li>
          <li parentName="ul"><strong parentName="li">{`IMPORTANT`}</strong>{`: If using Cocoapods, upgrading to the XCFrameworks distribution requires Cocoapods 1.10.0 or newer`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "oct-6-2020"
    }}>{`Oct 6, 2020`}</h2>
    <h3 {...{
      "id": "ios-analytics-240"
    }}>{`iOS Analytics 2.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Added error callbacks for following APIs getQueueSize, getTrackingIdentifier and getVisitorIdentifier. Instance of AdobeCallbackWithError can be passed to these API's as an arguement to receive error callbacks.`}</li>
      <li parentName="ul">{`Added an enhancement to append previous app id and previous os version to backdated session info hits.`}</li>
      <li parentName="ul">{`Changes to read from Assurance shared state.`}</li>
    </ul>
    <h2 {...{
      "id": "oct-5-2020"
    }}>{`Oct 5, 2020`}</h2>
    <h3 {...{
      "id": "android-analytics-126"
    }}>{`Android Analytics 1.2.6`}</h3>
    <ul>
      <li parentName="ul">{`Added error callbacks for following APIs getQueueSize, getTrackingIdentifier and getVisitorIdentifier. Instance of AdobeCallbackWithError can be passed to these API's as an arguement to receive error callbacks.`}</li>
      <li parentName="ul">{`Added an enhancement to append previous app id and previous os version to backdated session info hits.`}</li>
      <li parentName="ul">{`Changes to read from Assurance shared state.`}</li>
    </ul>
    <h2 {...{
      "id": "aug-4-2020"
    }}>{`Aug 4, 2020`}</h2>
    <h3 {...{
      "id": "android-analytics-125"
    }}>{`Android Analytics 1.2.5`}</h3>
    <ul>
      <li parentName="ul">{`Fixed TimeSinceLaunch not getting reported in analytics hits.`}</li>
      <li parentName="ul">{`Fixed a race condition which was causing a null pointer crash.`}</li>
    </ul>
    <h2 {...{
      "id": "june-17-2020"
    }}>{`June 17, 2020`}</h2>
    <h3 {...{
      "id": "ios-analytics-230"
    }}>{`iOS Analytics 2.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS compatibility`}</li>
      <li parentName="ul">{`Version 2.3.0 onwards, binaries are built with Xcode 11.0`}</li>
    </ul>
    <h2 {...{
      "id": "june-1-2020"
    }}>{`June 1, 2020`}</h2>
    <h3 {...{
      "id": "ios-analytics-224"
    }}>{`iOS Analytics 2.2.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed incorrect timezone offset calculation`}</li>
      <li parentName="ul">{`Fixed a crash which happened in Analytics::TrackLifecycle`}</li>
    </ul>
    <h2 {...{
      "id": "march-2-2020"
    }}>{`March 2, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-analytics-223"
    }}>{`iOS Analytics 2.2.3`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`AnalyticsResponse`}</inlineCode>{` events are now always dispatched regardless if the debugApi is enabled or if AAM forwarding is enabled.`}</li>
      <li parentName="ul">{`Report extension details to ACPCore for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h2 {...{
      "id": "february-13-2020"
    }}>{`February 13, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-analytics-124"
    }}>{`Android Analytics 1.2.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue which, was causing some hits to be delayed.`}</li>
      <li parentName="ul">{`Fixed an issue where `}<inlineCode parentName="li">{`AnalyticsResponse`}</inlineCode>{` events were not being dispatched even when the debug API was enabled.`}</li>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h2 {...{
      "id": "january-25-2020"
    }}>{`January 25, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-analytics-123"
    }}>{`Android Analytics 1.2.3`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`requestEventIdentifier`}</inlineCode>{` is now appended to all non-track events so that Lifecycle (or other extension events that are sent to Analytics) can be viewed with rich detail in Project Griffon.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-analytics-222"
    }}>{`iOS Analytics 2.2.2`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`requestEventIdentifier`}</inlineCode>{` is now appended to all non-track events so that Lifecycle (or other extension events that are sent to Analytics) can be viewed with rich detail in Project Griffon.`}</li>
    </ul>
    <h2 {...{
      "id": "october-28-2019"
    }}>{`October 28, 2019`}</h2>
    <p>{`The following change was made in this release:`}</p>
    <h3 {...{
      "id": "android-analytics-122"
    }}>{`Android Analytics 1.2.2`}</h3>
    <ul>
      <li parentName="ul">{`Analytics response content events now contain two new fields:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`hitHost`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`hitUrl`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <p>{`These fields contain the host and URL of the of the hit responsible for dispatching the response event.`}</p>
    <h3 {...{
      "id": "ios-analytics-221"
    }}>{`iOS Analytics 2.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Analytics response content events now contain two new fields:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`hitHost`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`hitUrl`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <p>{`These fields contain the host and URL of the of the hit responsible for dispatching the response event.`}</p>
    <h2 {...{
      "id": "october-7-2019"
    }}>{`October 7, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-analytics-121"
    }}>{`Android Analytics 1.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where, on start up, the Analytics database was being modified by multiple threads.`}</li>
    </ul>
    <h2 {...{
      "id": "september-10-2019"
    }}>{`September 10, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-analytics-120"
    }}>{`Android Analytics 1.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Added the following new pieces of data when reporting a crash:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`previousosversion`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`previousappid`}</inlineCode></li>
        </ul>
      </li>
      <li parentName="ul">{`Added support for the Griffon debug API.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`global.ssl`}</inlineCode>{` configuration settings are ignored, and SSL is enabled by default.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-analytics-220"
    }}>{`iOS Analytics 2.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for Griffon debug API.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`global.ssl`}</inlineCode>{` configuration settings are ignored, and SSL is enabled by default.`}</li>
    </ul>
    <h2 {...{
      "id": "july-9-2019"
    }}>{`July 9, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-analytics-212"
    }}>{`iOS Analytics 2.1.2`}</h3>
    <ul>
      <li parentName="ul">{`ACPAnalytics now correctly identifies Acquisition link event types.`}</li>
      <li parentName="ul">{`Fixes a compile-time error when using the "-all`}{`_`}{`load" linker flag.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      